/* eslint-disable camelcase */
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class LocaleService_TWIA {

    static getLocal_TWIA(country, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('locale_TWIA'),
            'getLocaleConfig_TWIA',
            [country],
            additionalHeaders
        );
    }

}